export function NavUserNameShow({ firstName, lastName }) {
  return <span className="nav__user-name">{`${firstName} ${lastName}`}</span>;
}
